<template>
	<v-dialog
		v-model="showDialog"
		content-class="dips-dialog dialog-over-whole-page"
		persistent
	>
		<div class="details-wrapper drinks extra">
			<div class="close-btn" @click.prevent="onClose()"></div>
			<v-container fluid class="details-container">
				<v-layout row class="text-center">
					<v-flex v-if="getDipsGroup" xs12 class="add-dips-dialog-title">
						{{ $t("utilityComponents.addDips.addDipsDialogTitle") }}
					</v-flex>
				</v-layout>
				<v-layout>
					<product-group-grid-gt3
						v-if="getDipsGroup"
						:group="filterGroupProducts(getDipsGroup)"
						:changeGroupProductSelection="changeGroupProductSelectionIndexWrapped(index)"
						:changeSubGroupProductSelection="changeSubGroupProductSelectionIndexWrapped(index)"
						:changeConfigSelection="changeConfigSelectionIndexWrapped(index)"
						:productSelection="productSelection"
						:productSelections="productSelections"
						:index="index"
						:showPrice=showPrice(getDipsGroup)
						:key="getDipsGroup.id"
						:isMenu="isMenu"
						:rootProduct="product"
					/>
				</v-layout>
				<v-flex row class="align-items-center dips-dialog-actions-part">
					<v-btn class="btn-transparent" @click.prevent="onClose()">
						{{ $t("utilityComponents.addDips.addDipsDialogReject") }}
					</v-btn>
					<v-btn class="btn-secondary" @click="onYesClick">
						{{ $t("utilityComponents.addDips.addDipsDialogAdd") }}
					</v-btn>
				</v-flex>
			</v-container>
		</div>
	</v-dialog>
</template>
<script>
import {
	forEachAsync,
	getBackImages,
	getMiscImageUrl,
	getStaticPath,
	removeUnavailableProducts,
	transformProductsToItems
} from "../../../../libraries/utils";
import {mapGetters} from "vuex";
import {mapProductSelection} from "../../../../domains2/orders/ProductSelection";
import {generateDifferentiatedGroups, noThanksObject} from "../../../../helper/ProductSelectionHelper";
import appConfig from "../../../../appconfig";
import {
	ADD_TO_CART_SINGLE_ITEM,
	CHECKOUT_RESET_WITH_LAST_UPDATE_TIME,
	REMOVE_FROM_CART,
	SAVE_PRODUCT,
	UPDATE_PRODUCT_SELECTIONS
} from "../../../../store/mutation-types";
import {flatten, cloneDeep} from "lodash";
import menuItemMixin from "../../../../mixins/menuItem.mixin";
import ProductGroupGridGt3 from "../../gt3/ProductCatalog/ProductGroupGrid-gt3.vue";
import {gtmTrackAddDipFromBasket} from "../../../../integrations/tracking/gtm/pages/dipsDialog.Gtm";
import HelloRetail from "../../../../integrations/recommendations/helloRetail/HelloRetail";

export default {
	name: "DipsDialog",
	components: {ProductGroupGridGt3},
	props: ["categoryId", "productId", "category", "productSelectionId", "showDialog", "onClose"],
	mixins: [menuItemMixin],
	data() {
		return {
			_item: null,
			productSelections: [],
			productSelection: null,
			index: 0,
			selectedSubproducts: [],
			product: undefined
		};
	},
	computed: {
		...mapGetters([
			"productCatalog",
			"tenantSpecificData",
			"featureToggles",
			"cachedPickupRules",
			"globalSelectedShop"
		]),
		staticPath() {
			return getStaticPath();
		},
		getDipsGroup() {
			return this.product.groups.find(group => group.options && group.options.groupType === "dips");
		},
		channelAlias() {
			return appConfig.channelAlias();
		},
		hasGroupsConfigs() {
			return this.product.options.showGroupConfigs !== false;
		}
	},
	beforeMount() {
		this.index = this.productSelections.findIndex(ps => ps.productSelectionId === this.productSelectionId);
		this.productSelection = this.productSelections[this.index];
		this.$store.commit(SAVE_PRODUCT, this.productId);
		this.$store.commit(UPDATE_PRODUCT_SELECTIONS, cloneDeep(this.productSelections));
	},
	created() {
		this._item= transformProductsToItems(
			[this.productCatalog.getProduct(this.productId)],
			this.productCatalog,
			this,
			this.tenantSpecificData.deliveryChoice
		)[0];
		this.productSelections = cloneDeep(this._item.productSelections);
		this.product = this._item.product;
	},
	methods: {
		generateDifferentiatedGroups,
		getImage(imageName) {
			return getMiscImageUrl(imageName);
		},
		backImg(product) {
			return getBackImages(product, appConfig.channelAlias() === "kiosk");
		},
		showPrice(group){
			return this.quantityByGroup(group) >= (group.options.freeQuantity || 0);
		},
		quantityByGroup(group){
			let groupFromSelection = null;
			const productSelection = this.productSelections.find(ps => ps.productSelectionId === this.productSelectionId);
			groupFromSelection = productSelection.groups.find(g => g.groupId === group.id);
			if(!groupFromSelection && groupFromSelection !== null){
				groupFromSelection = productSelection.groups[0].selectedProducts[0].groups.find(g => g.groupId === group.id);
			}
			let quantity = 0;
			groupFromSelection.selectedProducts.forEach(
				sp => {
					if(sp.quantity) {
						quantity += sp.quantity;
					}
				}
			);
			return quantity;
		},
		products(category) {
			if(category.channels.includes(this.channelAlias)) {
				switch (this.channelAlias) {
				case "kiosk" : {
					return category.elements
						.filter(element => element.objType === "GridBlockElement")
						.map(element => element.items)
						.map((itemsRow) => itemsRow.filter((element) => element.id))
						.flat();
				}
				case "desktopBrowser" : {
					return flatten(
						flatten(category.elements)
							.filter(element => element.props && element.props.products)
							.map(element => element.props.products)
					)
						.map(productId => this.productCatalog.getProduct(productId, true));
				}
				}
				return [];
			}
		},
		filterGroupProducts(group){
			return removeUnavailableProducts(
				group,
				this.productCatalog,
				this.cachedPickupRules,
				this.globalSelectedShop.id,
				this.tenantSpecificData.deliveryChoice
			);
		},
		realSubproductsOnly(selectedProducts) {
			return selectedProducts.filter(selectedProduct => selectedProduct !== noThanksObject.id);
		},
		onYesClick() {
			gtmTrackAddDipFromBasket(this, {productSelections: this.productSelections});
			HelloRetail.cartTracking(this);
			this.updateCart();
		},
		async updateCart() {
			const cleanProductSelections = mapProductSelection(
				this.productCatalog,
				this.productSelections,
				this.realSubproductsOnly
			);
			await this.$store.dispatch(REMOVE_FROM_CART, this.product.id);
			await forEachAsync(cleanProductSelections, ps => {
				ps.forceNewInCart = true;
				return this.$store.dispatch(ADD_TO_CART_SINGLE_ITEM, cloneDeep(ps));
			});
			await this.$store.dispatch(CHECKOUT_RESET_WITH_LAST_UPDATE_TIME);
			this.onClose();
		}
	}
};
</script>

<style scoped lang="scss">
	.list-container {
		padding: 10px 5px;
	}
	.background-surface {
		display: none;
	}
	/deep/ .v-dialog.dips-dialog {
		width: 1100px;
		height: 900px;
		border: 3px solid #26282C;
		background-color: #000000;
		position: relative;
		.add-dips-dialog-title {
			font-size: 28px;
			line-height: 30px;
			font-weight: 700;
			padding: 40px 0;
		}
		.addon-wrapper {
			height: 680px;
			overflow: auto;
		}
		.dips-dialog-actions-part {
			display: flex;
			padding: 16px;
			justify-content: space-between;
			.v-btn {
				width: 49% !important;
				height: 60px;
			}
			.btn-transparent {
				margin: 0;
			}
		}
		.close-btn {
			position: absolute;
			right: -23px;
			top: -23px;
			content: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MSIgaGVpZ2h0PSI1MSIgdmlld0JveD0iMCAwIDUxIDUxIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgICAgPGNpcmNsZSBjeD0iMjIuNSIgY3k9IjIyLjUiIHI9IjI0IiBmaWxsPSIjMDAwIiBzdHJva2U9IiMyNjI4MkMiIHN0cm9rZS13aWR0aD0iMyIvPgogICAgICAgIDxnIGZpbGwtcnVsZT0ibm9uemVybyIgc3Ryb2tlPSIjRkZGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNC42MDUuMzk1TC4yMzkgMTQuNzYxTS40NDIuNDQybDE0LjI3IDE0LjI3TC40NDIuNDQyeiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUgMTUpIi8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K);
			z-index: 1;
		}
	}
</style>
